<div fxLayout="row" style="padding: 20px 10px 20px 10px;">
    <div class="center-vertical" fxFlex="20%">
        <p>Total: {{this.showedRows.length}} sur {{totalRows}}</p>
    </div>
    <div class="center-vertical" fxFlex="40%" fxLayoutAlign="center center">
        <button type="button" class="button-secondary-small" (click)="contentsSetting()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
            <mat-icon fontIcon="settings" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
            <div>Setting Content</div>
        </button>
    </div>
    <div class="center-vertical" fxFlex="40%" style="display: flex; align-items: center;">
        <div style="margin-left: auto;">
            <input class="col-input" (keyup)="applyFilterLocal($event.target, 'all_column')" placeholder="Search">
        </div>
    </div>
</div>
<div class="table_div" style="height: calc(100% - 170px);">
    <div class="nav-preview" fxLayout="row" fxLayoutAlign="center center" style="float: bottom; position: absolute;">
        <mat-icon [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;" fontIcon="arrow_left" title="Previous" (click)="movePrevNextNavigation('prev')"></mat-icon>
        <span style="font-weight: bold;"> Nav {{ navIndex *  this.filterData.limit}} / {{ totalRows}}</span>
        <mat-icon [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'" style="padding-right: 10px; font-size: 40px; height: 40px;" fontIcon="arrow_right" title="Next" (click)="movePrevNextNavigation('next')"></mat-icon>
    </div>
    <table>
        <thead>
        <tr>
            <th><div class="column-name">Id</div></th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_content', 'number')"></mat-icon>
                <div class="column-name">Id Content</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_content')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'belongs', 'string')"></mat-icon>
                <div class="column-name">Belongs to</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'belongs')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'class', 'string')"></mat-icon>
                <div class="column-name">Class</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'class')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'study', 'string')"></mat-icon>
                <div class="column-name">Study</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'study')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'module', 'string')"></mat-icon>
                <div class="column-name">Module</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'module')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'year', 'string')"></mat-icon>
                <div class="column-name">Year / Name</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'year')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'period', 'string')"></mat-icon>
                <div class="column-name">Period</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'period')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'section', 'string')"></mat-icon>
                <div class="column-name">Section</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'section')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'type', 'string')"></mat-icon>
                <div class="column-name">Type / Chapter</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'type')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'subscribe', 'number')"></mat-icon>
                <div class="column-name">Subscribes</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'subscribe')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_project', 'number')"></mat-icon>
                <div class="column-name">Project</div>
                <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_project')"></div>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'state', 'string')"></mat-icon>
                <div class="column-name">State</div>
                <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'state')">
                    <mat-option [value]="''">Choose</mat-option>
                    <mat-option [value]="'classified,edited'">Clissified & Edited</mat-option>
                    <mat-option [value]="'classified'">Classified</mat-option>
                    <mat-option [value]="'edited'">Edited</mat-option>
                    <mat-option [value]="'raw'">Raw</mat-option>
                    <mat-option [value]="'archived'">Archived</mat-option>
                </mat-select>
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'active', 'boolean')"></mat-icon>
                <div class="column-name">Active</div>
                <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'active')">
                    <mat-option [value]="''">Choose</mat-option>
                    <mat-option [value]="'true'">True</mat-option>
                    <mat-option [value]="'false'">False</mat-option>
                </mat-select>
            </th>
            <th>
                <div style="display: flex; justify-content: center;"><input #checkedAllRef type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" (change)="selectAllOption($event.target)"></div>
            </th>
        </tr>
        </thead>
        <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
            <tr (click)="toggleRow(row, $event.target, row_tbody)">
                <td>{{i + 1}}</td>
                <td>{{ row['id_content'] }}</td>
                <td matTooltip="{{ row['belongs'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['belongs'] }}</td>
                <td>{{ row['class'] }}</td>
                <td>{{ row['study'] }}</td>
                <td>{{ row['module'] }}</td>
                <td style="white-space: nowrap;" matTooltip="{{ row['year_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['year_name'] }}</td>
                <td style="white-space: nowrap;">{{ row['period'] }}</td>
                <td>{{ row['section'] }}</td>
                <td >{{ row['type_chapter']}}</td>
                <td>{{ row['subscribe'] }}</td>
                <td>{{ row['id_project'] }}</td>
                <td [innerHTML]="row['state_format']"></td>
                <td [innerHTML]="row['active_format']"></td>
                <td class="to_skip_element select_container">
                    <div *ngIf="row['id_content_duplicate'] > 0 && row['state'] != 'archived'" class="duplicate-mark"></div>
                    <div style="display: flex;">
                        <input type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" (change)="selectRow($event.target, i)" [checked]="row['checked']">
                        <mat-icon sorted="" fontIcon="more_vert" style="color: gray; font-size: 20px;" (click)="contentOption(row)"></mat-icon>
                    </div>
                </td>
            </tr>
            <tr class="expand_detail" *ngIf="row['expanded']">
                <td colspan="15">
                    <app-vcl-detail-content [rowInfos]="row" [userInfos]="userInfos" (inProgress)="setWaiting($event)" (updateStates)="setUpdatedContent($event, platformInfos.key)" (updateContent)="setUpdatedContent($event, platformInfos.key)"></app-vcl-detail-content>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="showedRows.length === 0">
            <tr ><td colspan="15" style="text-align: center;">No matching records found</td></tr>
        </tbody>
    </table>
</div>